import { Component, OnInit } from '@angular/core';
import {AuthService} from '../auth.service';
import { Router } from '@angular/router';
import { ToastrManager } from 'ng6-toastr-notifications';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {
public header;
public cred = {
  poolId: localStorage.getItem("poolId"),
  clientId: localStorage.getItem("clientId"),
  region: localStorage.getItem("region")
};
  constructor( private auth: AuthService, 
    private router: Router,
    private toastr: ToastrManager,
    private spinner: NgxSpinnerService
    ){ }

  ngOnInit() {
    this.spinner.show();
 
    setTimeout(() => {
        /** spinner ends after 3 seconds */
        this.spinner.hide();
    }, 3000);
    this.auth.userLogout(this.cred).subscribe((Data: any) => {
      console.log(Data);
      localStorage.removeItem("pic");
      localStorage.removeItem('token');
      localStorage.removeItem('userName')
      localStorage.removeItem('loggedIn')
      this.toastr.successToastr("Logged out Successfully","Success!")
      this.router.navigate(["/login"]);
    })
  }

}
